import { DateTime } from "luxon";
import type { ImportItem, ImportSort } from "../api/types";

export type ImportMonthGroup = {
  month: string;
  imports: ImportItem[];
};

const NO_FIRST_TX = "No transactions yet";

export const groupImports = (
  imports: ImportItem[],
  sortBy: ImportSort,
): ImportMonthGroup[] => {
  const groups: ImportMonthGroup[] = [];
  let current: ImportMonthGroup | null = null;
  for (const item of imports) {
    const label = monthLabel(item, sortBy);
    if (!current || current.month !== label) {
      current = { month: label, imports: [] };
      groups.push(current);
    }
    current.imports.push(item);
  }
  return groups;
};

const monthLabel = (item: ImportItem, sortBy: ImportSort): string => {
  if (sortBy === "firstTxDateDesc") {
    if (!item.firstTransactionDate) return NO_FIRST_TX;
    return DateTime.fromISO(item.firstTransactionDate).toFormat("MMMM yyyy");
  }
  return DateTime.fromISO(item.dateImported).toFormat("MMMM yyyy");
};
